let langswitches = document.querySelectorAll(".js-Langswitch");
if (langswitches && langswitches.length > 0) {
    langswitches.forEach(langswitch => {
        langswitch.addEventListener("change", (event) => {
            window.location.href = langswitch.options[langswitch.selectedIndex].value;
        });
    });
}
